import axios from "axios"
import config from "../config"

export const isDevelopment = import.meta.env.MODE === 'development'
const baseUrl = isDevelopment ? config.development.apiBaseUrl : config.production.apiBaseUrl

export const AxiosInstance = axios.create({
    baseURL: baseUrl,
    timeout: 30000,
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
    },
    paramsSerializer: {
        encode: (params: string) => encodeURIComponent(params)
    }
})

// Request interceptor to add the JWT access token
AxiosInstance.interceptors.request.use((config) => {
    if (config.url) {
        config.url = config.url.split('/')
            .map((param) => encodeURIComponent(param))
            .join('/')
    }

    const accessToken = localStorage.getItem('accessToken')

    if (accessToken && accessToken !== 'undefined') {
        config.headers['Authorization'] = `Bearer ${accessToken}`
    }
    
    return config
}, (error) => {
    return Promise.reject(error)
})

// Response interceptor for handling token refresh on 401 errors
AxiosInstance.interceptors.response.use(
    (response) => response, 
    async (error) => {
        const originalRequest = error.config

        const refreshUrl = `${baseUrl}/auth/dj-rest-auth/token/refresh/` 

        if (error.response?.status === 401 && !originalRequest._retry && originalRequest.url !== refreshUrl) {
            originalRequest._retry = true 

            const refreshToken = localStorage.getItem('refreshToken')

            if (refreshToken) {
                try {
                    const refreshResponse = await axios.post(refreshUrl, { 
                        refresh: refreshToken,
                    })

                    const newAccessToken = refreshResponse.data.access
                    const newRefreshToken = refreshResponse.data.refresh

                    localStorage.setItem('accessToken', newAccessToken)
                    localStorage.setItem('refreshToken', newRefreshToken)

                    AxiosInstance.defaults.headers['Authorization'] = `Bearer ${newAccessToken}`
                    originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`

                    return AxiosInstance(originalRequest)
                } catch (refreshError) {
                    console.error('Unable to refresh token', refreshError)
                    localStorage.removeItem('accessToken')
                    localStorage.removeItem('refreshToken')
                    delete AxiosInstance.defaults.headers['Authorization']
                    return Promise.reject(refreshError)
                }
            } else {
                console.error('No refresh token available')
                localStorage.removeItem('accessToken')
                delete AxiosInstance.defaults.headers['Authorization']
                return Promise.reject(error)
            }
        }
        
        return Promise.reject(error)
    }
)

export default AxiosInstance